import { BudgetRecipient } from "../../enums/budgetRecipient";
import { UserProfileEnum, ProfileRouteMap } from "../../../../enums/profile";

const getBudgetsV2Route = (profile: UserProfileEnum): string => {
  return `${ProfileRouteMap[profile]}/budgets`;
};

export const getRouteByProfile = (profile: BudgetRecipient | string | undefined): string => {
  if (!profile) {
    return "";
  }

  if (profile === BudgetRecipient.TOWER) {
    return getBudgetsV2Route(UserProfileEnum.CONTROL_TOWER);
  }

  if (profile === BudgetRecipient.CONSULTANT) {
    return getBudgetsV2Route(UserProfileEnum.DEALERSHIP);
  }

  if (profile === BudgetRecipient.MANAGER) {
    return getBudgetsV2Route(UserProfileEnum.FLEET_MANAGER);
  }

  return "";
};

export const getKanbanRouteByProfile = (profile: BudgetRecipient | string | undefined): string => {
  if (!profile) {
    return "";
  }

  const profileStr = String(profile).toUpperCase();

  if (profileStr === "TOWER" || profileStr === "FACTORY") {
    return getBudgetsV2Route(UserProfileEnum.CONTROL_TOWER);
  }

  if (profileStr === "CONSULTANT") {
    return getBudgetsV2Route(UserProfileEnum.DEALERSHIP);
  }

  if (profileStr === "MANAGER") {
    return getBudgetsV2Route(UserProfileEnum.FLEET_MANAGER);
  }

  return "";
};
